import { config } from 'src/config/config';
import { withBasePath } from 'src/utils/routing';
import { router } from 'src/index';

class NavigationService {
  public static readonly STORE = '/store';
  public static readonly AUTH_CALLBACK = '/auth/callback';
  public static readonly LOGOUT = '/logout';
  public static readonly CHOOSE_ACCOUNT = '/choose-account';
  public static readonly CHOOSE_SERVICE_LOCATION = '/choose-address';
  public static readonly ERROR = '/error';
  public static readonly ERROR_NO_BROADBAND = '/no-broadband';
  public static readonly ERROR_NO_TV_OFFER = '/no-tv-offer';
  public static readonly ERROR_WRONG_TV_PLATFORM = '/wrong-tv-platform';
  public static readonly ERROR_NOT_AVAILABLE = '/not-available';
  public static readonly ERROR_NO_SERVICE_LOCATIONS = '/no-service-locations';
  public static readonly ERROR_MULTIPLE_TV_OFFERS = '/multiple-tv-offers';
  public static readonly ERROR_HAS_INFLIGHT_ORDER = '/in-flight-order';
  public static readonly ERROR_UNDER_MAINTENANCE = '/under-maintenance';
  public static readonly ERROR_RESTRICTED_PURCHASE = '/restricted-purchase';
  public static readonly ERROR_SESSION_EXPIRED = '/session-expired';
  public static readonly WRONG_ROLE = '/wrong-role';
  public static readonly SUMMARY = `${NavigationService.STORE}/cart`;
  public static readonly PRODUCT_PURCHASE = `${NavigationService.STORE}/product/purchase`;
  public static readonly PRODUCT_UPGRADE = `${NavigationService.STORE}/product/upgrade`;
  public static readonly PRODUCT_SELECT = `${NavigationService.STORE}/product-select`;
  public static readonly SUCCESS = `${NavigationService.STORE}/product/receipt`;
  public static readonly AUTH_REDIRECT_URL = withBasePath(NavigationService.AUTH_CALLBACK);

  public readonly goToPath = (path: string) => router.navigate(path);

  public readonly replacePath = (path: string) => router.navigate(path, { replace: true });

  public readonly goToMineSider = (): void => {
    window.location.href = config.MINE_SIDER;
  };

  public readonly goToMainPage = (): void => {
    window.location.href = config.MAIN_PAGE;
  };
}

const navigationService = new NavigationService();

export { navigationService, NavigationService };
